<div _ngcontent-oou-c51="" class="row" style="height:500px;padding-top: 120px;padding-bottom: 71px;">

    <p style="text-align: center;
 
    font-size: 46px;
    padding-top: 60px;
    font-family: fangsong;
    color: #532ABA;">Coming Soon...</p>
</div>